import styled from "styled-components";

export const CreateProgramTemplateActivitiesAndDeliverablesWrapper = styled.div`
  .cell-activity-type {
    min-width: 200px;
  }
  .cell-modality {
    min-width: 160px;
  }
  .cell-topics {
    min-width: 260px;
  }
  .cell-activity-class {
    min-width: 200px;
  }
  .cell-activity-status {
    min-width: 200px;
  }
  .cell-program-framework {
    min-width: 200px;
  }
  .cell-units {
    min-width: 150px;
  }
  .cell-measurement {
    min-width: 200px;
  }
  .cell-candidate-status {
    min-width: 200px;
  }
  .cell-actions {
    min-width: 140px;
  }
  .form-header-right > .MuiBox-root {
    margin-right: 28px;
    display: flex;
    justify-content: flex-end;
  }

  .action-btns {
    margin: 0 16px;
  }
`;
